import React, { useState, useEffect } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import { Typography } from "@mui/material";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import "../components/Table/Table.css";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import TopLoader from "../components/Loader/TopLoader";
import { handleConfirmDelivery, received } from "../api/Users";
import { toast } from "react-toastify";
import { TextField, TablePagination } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { Modal, Button } from "@mui/material";
import { Assignment, LocalShipping, Home } from "@material-ui/icons";
import { hostelconfirmRequirements, show_confirm_delivery } from "../api/Users";
import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";

import RedeemIcon from "@mui/icons-material/Redeem";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import { MDBTypography } from "mdb-react-ui-kit";

const ConfirmDelivery = ({ role, mainId, userData }) => {
  const { t } = useTranslation();

  const [isLoading, setIsLoading] = useState(true);
  const [rows, setRows] = useState([]);

  // Search and pagination
  const [photo, setPhoto] = useState(null);

  const [filteredData, setFilteredData] = useState([]);
  const [track, settrack] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [modalOpen, setModalOpen] = useState(false);

  const [basicModal, setBasicModal] = useState(false);

  const toggleShow = () => setBasicModal(!basicModal);

  const [selectedRow, setSelectedRow] = useState(null);
  const [confirmedRow, setconfirmedRow] = useState(null);
  const [newModal, setnewModal] = useState(false);
  const [invoiceData, setInvoiceData] = useState({
    deliveryDate: "",
    invoiceNumber: "",
    quantity: "",
    baseCost: "",
    GST: "",
    total: 0,
    file: "",
    UDISE_code: "",
    requirement_id: "",
    hostel_id: "",
    amenities_id: "",
    amenities_sub_type_id: "",
    school_id: "",
    proposed_quantity: "",
    gbc_id: "",
    proposed_amount: "",
    upload_confirmed_delivery_asset_photo: "",
  });
  console.log(filteredData)
  console.log(filteredData[0]?.fund_master_type_id);
  console.log(userData);

  const fetchconfirmRequirements = async () => {
    setIsLoading(true);
    try {
      const data = {
        school_id: userData.data.school_id,
        UDISE_code: userData.data.UDISE_code,
      };
      show_confirm_delivery(data).then((res) => {
        if (res.status == "success") {
          setRows(res.data.result);
          setFilteredData(res.data.result);
          setIsLoading(false);
        } else {
          setRows([]);
          setFilteredData([]);
          setIsLoading(false);
        }
      });
    } catch (error) {
      console.error("Error fetching data:", error);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchconfirmRequirements();
  }, []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleconfirm = (row) => {
    setnewModal(true);

    setInvoiceData({
      UDISE_code: row.UDISE_code,
      requirement_id: row.req_id,
      proposed_amount: row.tentative_amount,
      school_id: row.school_id,
      amenities_id: row.amenities_id,
      amenities_sub_type_id: row.amenities_sub_type_id,
      hostel_id: row.hostel_id,
      gbc_id: row.gbc_id,
      proposed_quantity: row.quantity,
    });
  };

  const handleCloseModal = () => {
    setnewModal(false);
  };

  const handlePhotoChange = (event) => {
    const file = event.target.files[0];
    if (!file) {
      toast.error("No Amenity Photo selected!");
      return;
    }
    const allowedExtensions = /(\.jpg|\.jpeg|\.png)$/i; // Allowed file types

    if (!allowedExtensions.test(file.name)) {
      toast.error("Invalid file type. Only JPG and PNG files are allowed.");
      event.target.value = "";
      return;
    }

    setInvoiceData({
      ...invoiceData,
      upload_confirmed_delivery_asset_photo: file,
    });
  };

  const handleInvoice = (e) => {
    const { name, value, type, files } = e.target;

    if (type !== "file") {
      setInvoiceData({ ...invoiceData, [name]: value });
    } else if (name === "quantity" || name === "basecost") {
      setInvoiceData({
        ...invoiceData,
        total: invoiceData.quantity * invoiceData.baseCost,
      });
    } else {
      const file = files[0];
      setInvoiceData({ ...invoiceData, file: file });
    }
  };

  const handleInvoiceSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);

    const formData = new FormData();

    formData.append("delivery_date", invoiceData.deliveryDate);
    formData.append("invoice_number", invoiceData.invoiceNumber);
    formData.append("actual_quantity", invoiceData.quantity);
    formData.append("base_cost", 0);
    formData.append("GST", 0);
    formData.append("actual_amount", 0);
    formData.append("UDISE_code", invoiceData.UDISE_code);
    formData.append("requirement_id", invoiceData.requirement_id);
    formData.append("hostel_id", invoiceData.hostel_id);
    formData.append("amenities_id", invoiceData.amenities_id);
    formData.append("amenities_sub_type_id", invoiceData.amenities_sub_type_id);
    formData.append("school_id", invoiceData.school_id);
    formData.append("proposed_quantity", invoiceData.proposed_quantity);
    formData.append("gbc_id", invoiceData.gbc_id);
    formData.append("proposed_amount", invoiceData.proposed_amount);
    formData.append("confirm_delivery", invoiceData.file);
    formData.append(
      "upload_confirmed_delivery_asset_photo",
      invoiceData.upload_confirmed_delivery_asset_photo
    );
    formData.append("fund_master_sub_type_id",filteredData[0]?.fund_master_sub_type_id);
    formData.append("fund_master_type_id",filteredData[0]?.fund_master_type_id);
    formData.append("district_code",userData.data.district_code);

    console.log(formData);

    handleConfirmDelivery(formData)
      .then((response) => {
        if (response.status == "success") {
          toast.success("Submitted Successfully");
          setInvoiceData({
            deliveryDate: "",
            invoiceNumber: "",
            quantity: "",
            baseCost: "",
            GST: "",
            total: "",
            bill: null,
            UDISE_code: "",
            requirement_id: "",
            hostel_id: "",
            amenities_id: "",
            amenities_sub_type_id: "",
            school_id: "",
            proposed_quantity: "",
            gbc_id: "",
            proposed_amount: "",
          });
          setIsLoading(false);
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        } else {
          setIsLoading(false);
        }
      })
      .catch((err) => {
        console.error("Error fetching Categories:", err);
      });
  };

  return (
    <>
      <TopLoader loading={isLoading ? "50" : "100"} />
      <div className="px-0 px-md-3">
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <div className="my-4 col-12 d-flex justify-content-between align-items-center">
            <h5 className=" mt-2">{t("Confirm Delivery")}</h5>
            <div className="">
              <TextField
                label={t("Search")}
                variant="outlined"
                fullWidth
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                InputProps={{
                  endAdornment: <SearchIcon />,
                }}
              />
            </div>
          </div>
        </div>

        <div className="Table mb-6">
          <TableContainer
            component={Paper}
            style={{
              boxShadow: "0px 13px 20px 0px #80808029",
              border: "1px solid gray",
            }}
            className="my-4"
          >
            <Table aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell align="center">{t("Sr. No.")}</TableCell>
                  <TableCell align="center">{t("Requirement")}</TableCell>
                  <TableCell align="center">{t("Hostel Name")}</TableCell>
                  <TableCell align="center">{t("Quantity")}</TableCell>
                  <TableCell align="center">{t("Action")}</TableCell>
                </TableRow>
              </TableHead>
              {!isLoading && filteredData && filteredData.length > 0 && (
                <TableBody style={{ color: "white" }}>
                  {filteredData
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, index) => (
                      <TableRow
                        key={index}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell align="center" component="th" scope="row">
                          {index + 1}
                        </TableCell>
                        <TableCell align="center">
                          {row.amenities_sub_type_name}
                        </TableCell>
                        <TableCell align="center" style={{ width: "15%" }}>
                          {row.hostel_type}
                        </TableCell>
                        <TableCell align="center">{row.quantity}</TableCell>
                        <TableCell align="center">
                          <Typography
                            className="success-btn btn btn-sm"
                            variant="contained"
                            onClick={() => handleconfirm(row)}
                            style={{
                              backgroundColor: "green",
                              color: "white",
                            }}
                          >
                            {t("Confirm Delivery")}
                          </Typography>
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              )}
              {!isLoading && (!filteredData || filteredData.length === 0) && (
                <TableRow>
                  <TableCell align="center" colSpan={7}>
                    <h4>
                      {" "}
                      <i>{t("No data available")}</i>{" "}
                    </h4>
                  </TableCell>
                </TableRow>
              )}
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[10, 25, 50]}
            component="div"
            count={filteredData.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </div>
      </div>

      {newModal && (
        <Modal
          open={newModal}
          onClose={handleCloseModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div
            style={{
              position: "relative",
              width: "90vw",
              backgroundColor: "#ffffff",
              boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
              borderRadius: 8,
              padding: 20,
              margin: "5rem",
            }}
          >
            <h2 className="fw-bold text-center">{t("Delivery Details")}</h2>
            <button
              onClick={handleCloseModal}
              style={{
                position: "absolute",
                right: "20px",
                top: "20px",
                border: "none",
                background: "none",
                fontSize: "1.5rem",
                cursor: "pointer",
              }}
            >
              &times;
            </button>
            <form onSubmit={handleInvoiceSubmit}>
              <TableContainer
                component={Paper}
                style={{ boxShadow: "0px 13px 20px 0px #80808029" }}
                className="my-4"
              >
                <Table aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell
                        align="center"
                        rowSpan={2}
                        className="border border-2"
                      >
                        {t("Delivery Date")}
                      </TableCell>
                      <TableCell
                        align="center"
                        rowSpan={2}
                        className="border border-2"
                      >
                        {t("Document Number")}
                      </TableCell>
                      <TableCell
                        align="center"
                        rowSpan={2}
                        className="border border-2"
                      >
                        {t("Quantity")}
                      </TableCell>
                      <TableCell
                        align="center"
                        rowSpan={2}
                        className="border border-2"
                      >
                        {t("Upload Amenity Photo")}
                      </TableCell>
                      <TableCell
                        align="center"
                        rowSpan={2}
                        className="border border-2"
                      >
                        {t("Upload Document")}
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" className="border border-2">
                        <input
                          type="date"
                          max={new Date().toISOString().split("T")[0]}
                          onChange={handleInvoice}
                          name="deliveryDate"
                          className="form-control"
                        />
                      </TableCell>
                      <TableCell align="center" className="border border-2">
                        <input
                          type="text"
                          onChange={handleInvoice}
                          name="invoiceNumber"
                          className="form-control"
                          onInput={(e) => {
                            e.target.value = e.target.value.replace(
                              /[^0-9]/g,
                              ""
                            );
                          }}
                          pattern="[1-9]\d*"
                          title="Please enter a positive integer"
                          required
                        />
                      </TableCell>
                      <TableCell align="center" className="border border-2">
                        <input
                          type="text"
                          onChange={handleInvoice}
                          name="quantity"
                          className="form-control"
                          onInput={(e) => {
                            e.target.value = e.target.value.replace(
                              /[^0-9]/g,
                              ""
                            );
                          }}
                          pattern="[1-9]\d*"
                          title="Please enter a positive integer"
                          required
                        />
                      </TableCell>
                      <TableCell align="center" className="border">
                        <input
                          type="file"
                          name="photo_file"
                          accept="image/*"
                          className="form-control"
                          onChange={handlePhotoChange}
                        />
                      </TableCell>
                      <TableCell align="center" className="border">
                        <input
                          type="file"
                          accept=".pdf, .jpg, .jpeg, .png"
                          onChange={handleInvoice}
                          name="bill"
                          className="form-control"
                          required
                        />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
              <div className="col-12 d-flex justify-content-end">
                <button type="submit" className="col-2 btn btn-primary">
                  {t("Submit")}
                </button>
              </div>
            </form>
          </div>
        </Modal>
      )}
    </>
  );
};

export default ConfirmDelivery;
